import React, { useContext, useState, useEffect, useMemo } from 'react';
import SortBy from './SortBy';
import Price from './Price';
import WaysToPay from './WaysToPay';
import Services from './Services';
import TradingHours from './TradingHours';
import Clear from './Clear';
import { Context } from '../../../context/AppContext';
import { MODALS, FILTERS } from '../../../constants';
import Share from '../Cards/Card/Share';
import FiltersMobile from './FiltersMobile';
import './styles.css';

const { PAYMENT_METHODS, PAY_LATER, OPENING_HOURS, PRICE_RANGE } = FILTERS;

const Filters = ({
  fetchMore,
  filters,
  params,
  fixed,
  showFiltersMobile,
  suburb,
  category,
  pathname,
  state,
  filtersCount,
  updateFiltersCount,
  SERVICE_CATEGORY,
}) => {
  const {
    media: { mobile, tablet },
    modal: { hideModal },
  } = useContext(Context);
  const modalName = MODALS.FILTERS_MOBILE;
  const { filter = '', sort } = params;

  const [selectedCount, setSelectedCount] = useState({});
  const [defaultServices, setDefaultServices] = useState([]);

  const updateDefaultServices = data => {
    setDefaultServices(
      defaultServices.map(item => ({
        ...item,
        checked: data.includes(item.value),
      }))
    );
  };

  const getCheckedFilters = value =>
    value.filter(({ checked }) => checked).length;

  const getActiveSort = value => (value || '').split(',').length;

  const {
    priceRange,
    paymentMethods,
    payLater,
    openingHours,
    serviceCategory,
  } = useMemo(() => {
    return {
      paymentMethods: PAYMENT_METHODS.map(item => ({
        ...item,
        checked: (filter || '').split(',').find(x => x === item.value),
      })),
      payLater: PAY_LATER.map(item => ({
        ...item,
        checked: (filter || '').split(',').find(x => x === item.value),
      })),
      openingHours: OPENING_HOURS.map(item => ({
        ...item,
        checked: (filter || '').split(',').find(x => x === item.value),
      })),
      priceRange: PRICE_RANGE.map(item => ({
        ...item,
        checked: (filter || '').split(',').find(x => x === item.value),
      })),
      serviceCategory: SERVICE_CATEGORY.map(item => ({
        ...item,
        checked: (filter || '').split(',').find(x => x === item.value),
      })),
    };
  }, [filters, filter]);

  useEffect(() => {
    setSelectedCount({
      sortSelectedCount: getActiveSort(sort),
      priceRangeSelectedCount: getCheckedFilters(priceRange),
      waysToPaySelectedCount: getCheckedFilters([
        ...paymentMethods,
        ...payLater,
      ]),
      openingHoursSelectedCount: getCheckedFilters(openingHours),
      serviceCategorySelectedCount: getCheckedFilters(serviceCategory),
    });
  }, [
    priceRange,
    payLater,
    paymentMethods,
    openingHours,
    serviceCategory,
    sort,
    params,
  ]);

  const {
    sortSelectedCount = 0,
    priceRangeSelectedCount = 0,
    waysToPaySelectedCount = 0,
    openingHoursSelectedCount = 0,
    serviceCategorySelectedCount = 0,
  } = selectedCount;

  return (
    <div className="Listview__Filters__content">
      {mobile ? (
        <FiltersMobile
          fetchMore={fetchMore}
          filters={filters}
          params={params}
          selectedCount={selectedCount}
          filtersCount={filtersCount}
          updateFiltersCount={updateFiltersCount}
          onClickOutside={() => {
            updateFiltersCount(filter);
            hideModal(modalName);
          }}
        />
      ) : (
        <>
          <SortBy
            selectedCount={sortSelectedCount}
            fetchMore={fetchMore}
            sort={sort}
            filter={filter}
            showFiltersMobile={showFiltersMobile}
          />
          <TradingHours
            selectedCount={openingHoursSelectedCount}
            fetchMore={fetchMore}
            filters={openingHours}
            filter={filter}
            filtersCount={filtersCount}
            updateFiltersCount={updateFiltersCount}
            sort={sort}
          />
          <Price
            selectedCount={priceRangeSelectedCount}
            fetchMore={fetchMore}
            filters={priceRange}
            filter={filter}
            filtersCount={filtersCount}
            updateFiltersCount={updateFiltersCount}
            sort={sort}
          />
          <WaysToPay
            selectedCount={waysToPaySelectedCount}
            fetchMore={fetchMore}
            filters={[...paymentMethods, ...payLater]}
            filter={filter}
            filtersCount={filtersCount}
            updateFiltersCount={updateFiltersCount}
            sort={sort}
          />
          <Services
            selectedCount={serviceCategorySelectedCount}
            fetchMore={fetchMore}
            filters={serviceCategory}
            filter={filter}
            defaultServices={defaultServices}
            updateDefaultServices={updateDefaultServices}
            filtersCount={filtersCount}
            updateFiltersCount={updateFiltersCount}
            sort={sort}
          />

          <Clear fetchMore={fetchMore}>{fixed && 'Clear filters'}</Clear>

          {tablet && (
            <Share
              url={pathname}
              name={`${category} in ${suburb}`}
              suburb={suburb}
              state={state}
              text="Share list"
            />
          )}
        </>
      )}
    </div>
  );
};

export default Filters;
